var React = require('react');

function IconAgilePipelineLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M623.8 191.2h1.1c79.5 0 143.9 64.4 143.9 143.9v351.6c0 79.5-64.4 143.9-143.9 143.9H622c-59.9 0-116.3-28-152.6-75.6L256.2 513l213.3-243.9c36.2-49 93.4-77.9 154.3-77.9z"}));
}

IconAgilePipelineLeft.displayName = "IconAgilePipelineLeft";

IconAgilePipelineLeft.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconAgilePipelineLeft;

IconAgilePipelineLeft.default = IconAgilePipelineLeft;
